import React, { ReactElement } from "react"
import { Link } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconProp } from "@fortawesome/fontawesome-svg-core"

type Props = {
  label: string
  value?: string
  action?: () => void
  icon?: IconProp
  isLoading?: boolean
  linkTo?: string
}

const RenderRow = ({ label, value, action, icon, isLoading, linkTo = "" }: Props): ReactElement => {
  const RenderValue = (): ReactElement => {
    if (!value || value.includes("hidden")) {
      return <span className="text-gray-400">{!value ? "N/A" : value}</span>
    }
    if (linkTo) {
      return (
        <Link to={linkTo} className="text-brand-01">
          {value}
        </Link>
      )
    }

    return <span>{value}</span>
  }

  return (
    <tr className="h-8 border-b border-solid border-gray-200">
      <th className="text-start font-bold align-middle">{label}:</th>
      <td className="px-4 align-middle">
        <RenderValue />

        {value && icon && action && (
          <FontAwesomeIcon icon={icon} className="text-blue-500 cursor-pointer ml-1.5" onClick={action} />
        )}

        {isLoading && <FontAwesomeIcon icon="spinner" className="text-blue-500 cursor-pointer ml-1.5" />}
      </td>
    </tr>
  )
}

export default RenderRow
